






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { toNumber } from '@/utils/filters'

@Component
export default class ProgressBar extends Vue {
  @Prop() public value: any;
  @Prop() public max: any;

  get actualValue() {
    return toNumber(this.value)
  }

  get maxValue() {
    return toNumber(this.max)
  }
}
